/** localStorage keys for PWA UX (non-sensitive preferences only). */

export const PWA_STORAGE_KEYS = {
  /** User dismissed the Android install banner (ISO timestamp). */
  androidBannerDismissedAt: "pwa.androidBannerDismissedAt",
  /** User dismissed the iOS add-to-home instructions (ISO timestamp). */
  iosInstructionsDismissedAt: "pwa.iosInstructionsDismissedAt",
  /**
   * When "1", apply installed-app layout tweaks (safe areas, hide browser-only hints).
   * Auto-enabled in standalone; user can turn off in App settings.
   */
  preferAppLayout: "pwa.preferAppLayout",
};

const DISMISS_TTL_MS = 7 * 24 * 60 * 60 * 1000;

function readTimestamp(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const ts = Date.parse(raw);
    return Number.isNaN(ts) ? null : ts;
  } catch {
    return null;
  }
}

function writeTimestamp(key) {
  try {
    localStorage.setItem(key, new Date().toISOString());
  } catch {
    /* ignore quota / private mode */
  }
}

export function isDismissedRecently(key) {
  const ts = readTimestamp(key);
  if (!ts) return false;
  return Date.now() - ts < DISMISS_TTL_MS;
}

export function dismissForAWhile(key) {
  writeTimestamp(key);
}

export function readPreferAppLayout() {
  try {
    const v = localStorage.getItem(PWA_STORAGE_KEYS.preferAppLayout);
    if (v === "0") return false;
    if (v === "1") return true;
  } catch {
    /* ignore */
  }
  return null;
}

export function writePreferAppLayout(enabled) {
  try {
    localStorage.setItem(PWA_STORAGE_KEYS.preferAppLayout, enabled ? "1" : "0");
  } catch {
    /* ignore */
  }
}

/** Show Android / iOS install hints again after the user dismissed them. */
export function clearInstallDismissals() {
  try {
    localStorage.removeItem(PWA_STORAGE_KEYS.androidBannerDismissedAt);
    localStorage.removeItem(PWA_STORAGE_KEYS.iosInstructionsDismissedAt);
  } catch {
    /* ignore */
  }
}
